import { render, staticRenderFns } from "./FreightTemplate.vue?vue&type=template&id=170b7f7f&scoped=true&"
import script from "./FreightTemplate.vue?vue&type=script&lang=js&"
export * from "./FreightTemplate.vue?vue&type=script&lang=js&"
import style0 from "../style.scss?vue&type=style&index=0&id=170b7f7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170b7f7f",
  null
  
)

export default component.exports